export default __webpack_public_path__ + "static/media/Ellipse2.ac3a4860.svg";